import React from 'react';
import { cva } from 'class-variance-authority';

const buttonStyles = cva(
  'inline-flex items-center justify-center rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default: '',
        ghost: '',
        outline: 'border',
      },
      size: {
        sm: 'px-2 py-1 text-xs',
        md: 'px-3 py-2 text-sm',
        lg: 'px-4 py-2 text-sm',
        icon: 'p-2',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  className?: string;
  variant?: 'default' | 'ghost' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'icon';
  style?: React.CSSProperties;
}

const Button = ({ children, className = '', variant, size, style, ...props }: ButtonProps): React.ReactElement => {
  return (
    <button className={`${buttonStyles({ variant, size })} ${className}`.trim()} style={style} {...props}>
      {children}
    </button>
  );
};

export default Button;
